import { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import {
  useFollowUserMutation,
  useUnfollowUserMutation,
} from '@/redux/follow/follow.api.slice';

interface FollowButtonProps {
  targetUserId: string;
  isFollowing: boolean;
  isOwnProfile: boolean;
}

function FollowButton({
  targetUserId,
  isFollowing,
  isOwnProfile,
}: FollowButtonProps) {
  const [following, setFollowing] = useState(isFollowing);

  useEffect(() => {
    setFollowing(isFollowing);
  }, [isFollowing]);

  const [followUser, { isLoading: isFollowLoading }] = useFollowUserMutation();
  const [unfollowUser, { isLoading: isUnfollowLoading }] =
    useUnfollowUserMutation();

  if (isOwnProfile) {
    return null;
  }

  const handleToggle = async () => {
    const prev = following;
    setFollowing(!prev);
    try {
      if (prev) {
        await unfollowUser(targetUserId).unwrap();
      } else {
        await followUser(targetUserId).unwrap();
      }
    } catch {
      setFollowing(prev);
    }
  };

  const isLoading = isFollowLoading || isUnfollowLoading;

  return (
    <Button
      variant={following ? 'outline' : 'default'}
      className="w-full"
      onClick={handleToggle}
      disabled={isLoading}
    >
      {following ? 'Following' : 'Follow'}
    </Button>
  );
}

export default FollowButton;
